import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00cf88f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "preview-dialog"
};
const _hoisted_2 = {
  class: "preview-content"
};
const _hoisted_3 = {
  style: {
    "height": "100%",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "flex-direction": "column",
    "padding": "0px 150px"
  }
};
const _hoisted_4 = {
  class: "file-item"
};
const _hoisted_5 = {
  class: "file-header"
};
const _hoisted_6 = {
  class: "preview-box"
};
const _hoisted_7 = {
  key: 0,
  class: "error-box",
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "flex-direction": "column",
    "height": "100%",
    "width": "100%"
  }
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加载失败", -1));
const _hoisted_10 = {
  key: 1,
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_11 = {
  class: "error-box",
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "flex-direction": "column",
    "height": "100%",
    "width": "100%"
  }
};
const _hoisted_12 = ["src"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加载失败", -1));
const _hoisted_14 = {
  key: 2,
  class: "error-box",
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "flex-direction": "column",
    "height": "100%",
    "width": "100%"
  }
};
const _hoisted_15 = ["src"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂不支持预览", -1));
const _hoisted_17 = {
  key: 0,
  class: "menu-box"
};
import { Close } from '@element-plus/icons-vue';
import { EnumFileType } from '@/common/staticDict/index';
import fileErrorImg from '@/assets/img/file-error.png';
import { useDownload } from '@/common/hooks/useDownload';
import { getFileType } from '@/common/utils';
import PdfPreview from './Pdf.vue';
import WordPreview from './Word.vue';
import ExcelPreview from './Excel.vue';
import VideoPreview from './Video.vue';

import { ref, watch, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    fileList: {
      default: () => []
    },
    defaultIndex: {
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'delete', 'download'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      downloadFile
    } = useDownload();
    const ready = ref(false);
    const getFileList = ref([]);
    const onPreviewError = (file, err) => {
      file.error = true;
      getFileList.value = [...getFileList.value];
    };
    const closeDialog = () => {
      emit('close');
    };
    const getFileTypeByName = file => {
      if (file && file.type) {
        return file.type;
      } else {
        return getFileType(file.name);
      }
    };
    const getComponent = file => {
      switch (file.type) {
        case EnumFileType.PDF:
          return PdfPreview;
        case EnumFileType.WORD:
          return WordPreview;
        case EnumFileType.EXCEL:
          return ExcelPreview;
        case EnumFileType.VIDEO:
          return VideoPreview;
        default:
          return null;
      }
    };
    const onDeleteFile = file => {
      let temp = props.fileList.filter(item => item.url !== file.url);
      emit('delete', file, temp);
    };
    const onDownloadFile = file => {
      downloadFile(file.url, file.name);
      emit('download', file);
    };
    watch(() => props.fileList, val => {
      getFileList.value = val.map(file => {
        return {
          ...file,
          type: getFileTypeByName(file),
          error: false
        };
      });
    }, {
      immediate: true
    });
    onMounted(() => {
      // 如果没有延迟element的走马灯组件会有布局错乱问题
      setTimeout(() => {
        ready.value = true;
      }, 400);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        width: "80vw",
        modelValue: _ctx.visible,
        top: "15vh",
        "append-to-body": true,
        class: "dialog-preview",
        "show-close": false,
        "destroy-on-close": true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_carousel, {
          ref: "carousel",
          "initial-index": _ctx.defaultIndex,
          height: "100%",
          autoplay: false,
          arrow: _unref(getFileList).length > 1 ? 'hover' : 'never',
          style: _normalizeStyle([{
            "display": "flex",
            "height": "100%"
          }, {
            width: _unref(ready) ? '100%' : '0px'
          }]),
          "indicator-position": "none"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getFileList), (file, index) => {
            return _openBlock(), _createBlock(_component_el_carousel_item, {
              key: file.url
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(file.name), 1), _createVNode(_component_el_icon, {
                style: {
                  "cursor": "pointer"
                },
                onClick: closeDialog
              }, {
                default: _withCtx(() => [_createVNode(_unref(Close))]),
                _: 1
              })]), _createElementVNode("div", _hoisted_6, [file.error ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
                src: _unref(fileErrorImg),
                alt: "error"
              }, null, 8, _hoisted_8), _hoisted_9])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [file.type === _unref(EnumFileType).IMAGE ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                src: file.url,
                style: {
                  "width": "100%",
                  "height": "100%"
                },
                fit: "contain"
              }, {
                error: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
                  src: _unref(fileErrorImg),
                  alt: "error"
                }, null, 8, _hoisted_12), _hoisted_13])]),
                _: 2
              }, 1032, ["src"])) : getComponent(file) != null ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(file)), {
                key: 1,
                style: {
                  "width": "100%",
                  "height": "100%"
                },
                "file-url": file.url,
                time: index === _ctx.defaultIndex ? 10 : 10,
                onError: err => onPreviewError(file, err)
              }, null, 40, ["file-url", "time", "onError"])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("img", {
                src: _unref(fileErrorImg),
                alt: "error"
              }, null, 8, _hoisted_15), _hoisted_16]))]))])]), !_ctx.readonly ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_renderSlot(_ctx.$slots, "default"), _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                style: {
                  "width": "80px"
                },
                onClick: $event => onDownloadFile(file)
              }, {
                default: _withCtx(() => [_createTextVNode(" 下载 ")]),
                _: 2
              }, 1032, ["onClick"])])) : _createCommentVNode("", true)])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 3
        }, 8, ["initial-index", "arrow", "style"])])])]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
});